<script>
import { healthRecordService } from '@services/safehaven/HealthRecordService'

export default {
  created() {
    localStorage.clear()
  },
  mounted() {
    this.validateURL()
  },
  methods: {
    validateURL() {
      const obj = {
        uid: this.$route?.path.split('/')[3],
        token: this.$route?.path.split('/')[4],
      }
      localStorage.setItem('qrTokenDetails', JSON.stringify(obj))
      healthRecordService.validateQrUrl(obj).then(
        (res) => {
          if (res.data.has_expired) {
            this.$router.push({
              name: 'share-record-link-expired',
              params: { base: 'health-record' },
            })
          } else {
            this.$router.push({
              name: 'recipient-qr-code-verification',
              params: { recipientData: res.data },
            })
          }
        },
        (err) => {
          console.warn(err)
          this.$router.push({
            name: 'share-record-link-expired',
          })
        }
      )
    },
  },
}
</script>

<template>
  <v-progress-circular
    :size="150"
    :class="$style.loader"
    color="primary"
    indeterminate
  ></v-progress-circular>
</template>

<style lang="scss" module>
@import '@design';

.loader {
  display: flex;
  margin: auto;
  margin-top: 30vh;
}
</style>
